<template>
  <b-form @submit.prevent="$emit('submit')">
    <b-form-group label="Nombre">
      <b-form-input
        v-model="duracionContrato.nombre"
        required
        type="text"
        placeholder="Nombre de la duración del contrato"
      />
    </b-form-group>
    <b-form-group label="Meses">
      <b-form-input
        v-model="duracionContrato.meses"
        required
        type="number"
        placeholder="Meses de duración del contrato"
      />
    </b-form-group>
    <botonera-edicion url-cancelar="/duracionesContrato">
      <b-button
        v-show="duracionContrato.id > 0"
        :to="`/duracionesContrato/descuentos/${duracionContrato.id}?from=editar`"
        type="button"
        variant="dark"
      >
        Descuentos
      </b-button>
    </botonera-edicion>
  </b-form>
</template>
<script>
export default {
  props: {
    duracionContrato: {
      type: Object,
      required: true,
    },
  },
};
</script>
